<script lang="ts">
	import TextField from "@components/momentum/text-field/TextField.svelte";
	import { useAlgoliaClient } from "@stores/algolia";
	import {
		coordinates,
		locationInputQuery,
		locationPrompted,
		locationQuery
	} from "@stores/searchQuery";
	import LocationIcon from "@svg/Location.svelte";
	import { navigate } from "astro:transitions/client";
	import { createEventDispatcher, onMount, tick } from "svelte";
	import {
		municipalities,
		places,
		type TPlace
	} from "./dutchCitiesAndTowns.ts";
	import LocationFilteredPlaces from "./LocationFilteredPlaces.svelte";
	import { filteredPlaces } from "./store.ts";

	let { fetchLocation, performSearch } = useAlgoliaClient();

	let inputRef: HTMLInputElement;
	export let borderless = false;
	export let focused = false;
	export let withOptions = true;
	export let inputClass = "";
	export let optionsShadow = "shadow-lg";
	export let requestGeolocation = false;

	const dispatch = createEventDispatcher();

	const setInputVal = (placeName: string, municipalityIndex: number) => {
		// The city or village name plus the name of the municipality, for more specificity.
		$locationInputQuery =
			removeBold(placeName) + ", " + municipalities[municipalityIndex];
		$locationQuery = $locationInputQuery;
		$filteredPlaces = [];

		//string to search for
		return $locationInputQuery;
	};

	const navigateToNextPage = () => {
		if (
			window.location.pathname === "/profile/location/" ||
			window.location.pathname === "/profile/location"
		) {
			navigate("/profile");
		}
	};

	const removeBold = (str: string) => {
		return str.replace(/<(.)*?>/g, "");
	};

	const makeMatchBold = (str: string) => {
		let matched = str.substring(0, $locationInputQuery.length);
		let makeBold = `<strong>${matched}</strong>`;
		let boldedMatch = str.replace(matched, makeBold);
		return boldedMatch;
	};

	const filterPlaces = () => {
		let storageArr: Array<TPlace> = [];
		if ($locationInputQuery) {
			places.forEach((placeArray) => {
				const place = placeArray[0];
				const municipalityIndex = placeArray[1];
				const provinceIndex = placeArray[2];
				if (place.toLowerCase().startsWith($locationInputQuery.toLowerCase())) {
					storageArr = [
						...storageArr,
						[makeMatchBold(place), municipalityIndex, provinceIndex]
					];
				}
			});
		}
		$filteredPlaces = storageArr;
	};

	onMount(() => {
		$locationInputQuery = $locationQuery;

		navigator.permissions.query({ name: "geolocation" }).then((result) => {
			if (result.state === "granted") {
				requestGeolocationFc();
			}
		});
	});

	function requestGeolocationFc() {
		navigator.geolocation.getCurrentPosition(
			// accepted
			async function (position) {
				inputRef.blur();
				await tick();
				$locationQuery = "Je locatie";
				$locationInputQuery = $locationQuery;

				$coordinates = [position.coords.latitude, position.coords.longitude];

				// call performSearch if user is on results page
				if (window.location.pathname === "/") {
					performSearch();
				}
				if (window.location.pathname.includes("/profile/location")) {
					navigate("/");
				}
				open = false;

				$locationPrompted = true;
			},
			// denied
			function () {
				$locationPrompted = true;
			}
		);
	}

	let popperRef: HTMLElement;
	let open = false;

	$: {
		if (
			(focused && !$locationPrompted && !$locationQuery) ||
			(window &&
				window.location.pathname.includes("/profile/location") &&
				!$locationQuery) ||
			requestGeolocation
		) {
			console.log("hello???");
			// First check if the Permissions API is supported
			if ("permissions" in navigator) {
				navigator.permissions.query({ name: "geolocation" }).then(
					(result) => {
						if (result.state === "prompt" || result.state === "granted") {
							requestGeolocationFc();
						} else {
							$locationPrompted = true;
						}
					},
					(error) => {
						// If query fails, fall back to direct geolocation request
						requestGeolocationFc();
					}
				);
			} else {
				// Permissions API not supported (Safari), try direct geolocation
				requestGeolocationFc();
			}
		}
	}
</script>

<form
	class=" relative w-full"
	autocomplete="off"
	on:submit|preventDefault={() => {
		navigateToNextPage();
	}}
>
	<TextField
		class={inputClass}
		bind:focused
		{borderless}
		helperTextWhiteSpace={false}
		bind:ref={inputRef}
		placeholder="Voer hier jouw regio in"
		bind:value={$locationInputQuery}
		on:input={filterPlaces}
		on:focus={() => {
			//first let user promt
			$locationInputQuery = "";
			open = true;
		}}
		on:keydown={(event) => {
			if (event.key === "ArrowDown") {
				event.preventDefault();
				open = true;
				(popperRef.children.item(0) as HTMLElement)?.focus();
			}
		}}
		on:blur={(event) => {
			if (!popperRef.contains(event.relatedTarget as HTMLElement)) {
				$locationInputQuery = $locationQuery;
			}
		}}
	>
		<div class="flex items-center" slot="before">
			{#if withOptions}
				<LocationIcon
					class="h-6 w-6 {$locationQuery ? 'fill-secondary' : 'fill-gray-500'} "
				/>
			{/if}
		</div>

		<ul
			bind:this={popperRef}
			slot="popper"
			class="absolute top-10 z-50 w-full rounded-lg"
		>
			{#if open}
				<LocationFilteredPlaces
					shadow={optionsShadow}
					on:blur={(event) => {
						if (
							!popperRef.contains(
								(
									(event instanceof FocusEvent
										? event
										: event.detail) as FocusEvent
								).relatedTarget as HTMLElement
							)
						) {
							open = false;
						}
					}}
					on:click={async (event) => {
						const { placeName, municipalityIndex } = event.detail;
						const searchLocation = setInputVal(placeName, municipalityIndex);
						await fetchLocation(searchLocation);
						await navigateToNextPage();

						if (window.location.pathname === "/") {
							performSearch();
						}
						dispatch("select");
					}}
				/>
			{/if}
		</ul>
	</TextField>
</form>
